module.exports = __webpack_public_path__ + "0cebf9ac96fca41b41a6f13ad395977e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/writing-white.png
// module id = 3708
// module chunks = 0